export default function calculateCompletion(sectionsResults) {
  if (!sectionsResults || typeof sectionsResults !== 'object') return 0;
  
  const keys = Object.keys(sectionsResults);
  if (keys.length === 0) return 0;
  
  let total = 0;
  keys.forEach(k => {
    total += sectionsResults[k]?.percentage || 0;
  });
  
  return Math.round(total / keys.length);
}
